/* eslint-disable import/prefer-default-export */
//
// Track 2 eligibility-review chat — routes through the central agenticApiClient
// so it picks up the BFF-minted JWT + function-key defense-in-depth + CSRF.
// Do NOT add a `token` parameter back; the central client handles auth.
import { agenticPost } from '../../utils/agenticApiClient';

export async function sendEligibilityReviewAgentMessage({ message, threadId, run_id}) {
  return agenticPost('/api/policy-compliance/chat', {
    message,
    ...(threadId && { thread_id: threadId }),
    ...(run_id ? {run_id}:{}),
  });
}
